import { RETAILER_CONFIG_MAP, RetailerKey } from './retailer-config';

const AMAZON_KEYS: readonly RetailerKey[] = [RetailerKey.AmazonUS, RetailerKey.AmazonUK];

// Exactly one Amazon marketplace can be enabled at a time: every Amazon region
// shares the same ASIN format, so enabling two makes input detection ambiguous.
export function getEnabledRetailerKeys(flags: { walmart: boolean; amazon?: RetailerKey }): RetailerKey[] {
  const amazon = flags.amazon && AMAZON_KEYS.includes(flags.amazon) ? flags.amazon : RetailerKey.AmazonUS;
  const keys: RetailerKey[] = [amazon];
  if (flags.walmart) keys.push(RetailerKey.WalmartUS);
  return keys;
}

export function toRetailerKey(value: string | null | undefined): RetailerKey | null {
  const keys = Object.values(RetailerKey) as string[];
  return value && keys.includes(value) ? (value as RetailerKey) : null;
}

export function detectRetailerFromInput(value: string, enabledKeys: RetailerKey[]): RetailerKey | null {
  if (!value) return null;
  const entries = enabledKeys.map((k) => RETAILER_CONFIG_MAP[k]);
  const fullMatches = entries.filter((c) => c.itemIdPattern.test(value));
  if (fullMatches.length === 1) return fullMatches[0].key;
  if (fullMatches.length > 1) return null;

  const partialMatches = entries.filter((c) => c.detectionPattern.test(value));
  return partialMatches.length === 1 ? partialMatches[0].key : null;
}
